import typeahead from 'netc-typeahead';

$('html').click(() => {
  const $searchBox = $('.searchBox');
  if ($searchBox.hasClass('open-search')) {
    $searchBox.removeClass('open-search');
    return false;
  }

  return true;
});

$('.searchBox').click(function click(e) {
  e.stopPropagation();
  const $this = $(this);
  const $searchBox = $this.closest('.searchBox');
  if (!$searchBox.hasClass('open-search')) {
    $searchBox.addClass('open-search');

    const $searchInput = $searchBox.find('.tt-input');
    $searchInput.focus();
  } else {
    return true;
  }

  return false;
});

if ($('.searchBox').length > 0) {
  const $searchBox = $('.searchBox input[type=text]');
  const placeholder = $searchBox.attr('placeholder');
  typeahead.initialise($searchBox);
  $searchBox.attr('placeholder', placeholder);
}
